import { VALTYPES } from '../../../../data/interfaces';
import { createColorMappingAspect, createColorMappingConfigs } from '../../helpers/colorMappingInfo';

import { TpChartManifestAspectDef } from '../interfaces';
import { TpChartManifest } from '../interfaces';
import { SunBurst } from './SunBurst';

export const sunBurstMaxLevelCount = 6;

const levels: TpChartManifestAspectDef[] = [];
for (let i = 0; i < sunBurstMaxLevelCount; i++) {
  let description = 'Categorical property defining the innermost level.';
  if (i > 0)
    description = `Optional categorical property defining the next level. The states in this property should be a partioning of the states defined by \`level_${i}\`.`;
  levels.push({
    id: `level_${i + 1}`,
    name: `Level ${i + 1}`,
    groupId: 'categories',
    description,
    required: i < 1,
    quality: 0.9 ** i,
    dataType: VALTYPES.CATEGORICAL,
  });
}

export const manifestSunBurst: TpChartManifest = {
  id: 'SunBurst',
  name: 'Sunburst',
  description: `Used to visualize hierarchical categorical data, visualized as a set of concentric pie charts.
  
The plot can visualise up to ${sunBurstMaxLevelCount} levels, each one represented by a different plot aspect. In case fewer levels are used, the remaining aspects can be left unassigned.

Example usage:
- Display metagenomic data on multiple taxonomical levels.`,
  component: SunBurst,
  canvasBased: true,
  groups: [
    { groupId: 'categories', groupName: 'Categories' },
    { groupId: 'segments', groupName: 'Segments' },
  ],
  aspects: [
    ...levels,
    {
      id: 'angle',
      name: 'Summed angle',
      groupId: 'segments',
      description: 'The sum of the property values defines the relative angle in each segment.',
      required: false,
      quality: 0.25,
      dataType: [VALTYPES.NUMBER, VALTYPES.INTEGER],
    },
    // Sunburst only accepts numerical color mapping at the moment.
    createColorMappingAspect('color', 'Color', 'segments', 0.5, 'segments', [VALTYPES.NUMBER]),
  ],
  configParams: [...createColorMappingConfigs('color', 'Color', 'segments')],

  examples: [
    {
      id: 'sunburst_1',
    },
  ],
};
